import { useQuery } from "@tanstack/react-query";
import FullScreenModal from "../../../components/FullScreenModal";
import { api } from "../../../helpers/api";
import { Tabs } from "./components/Tabs";
import { UserInfo } from "./components/UserInfo";
import { Settings } from "./settings/Settings";
import { useState } from "react";
import { Analytics } from "./dashboard/Dashboard";
import { Calendar } from "./calendar/Calendar";
import { Marketing } from "./marketing/Marketing";
import { Pricing } from "./pricing/Pricing";
import { BrandAssets } from "../../../components/BrandAssets";
import { ConfirmBlock } from "../components/DeactivateModal";
import { ConfirmDelete } from "../components/DeleteUserModal";

export function UserDetails({
  isOpen,
  handleClose,
  userId,
  userData,
  onDeactivate,
  onDelete,
}: {
  isOpen: boolean;
  handleClose: () => void;
  userId: string;
  userData?: any;
  onDeactivate: () => void;
  onDelete: () => void;
}) {
  const [activeTab, setActiveTab] = useState("analytics");
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["user", userId],
    queryFn: () => api.getUser(userId),
    enabled: !!userId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchIntervalInBackground: false,
  });

  return (
    <>
      <FullScreenModal
        isOpen={isOpen}
        onClose={handleClose}
        contentClassName="bg-surface-tertiary"
        customContentClassName="[&>div]:lg:w-[1252px] [&>div]:qhd:w-[1700px] [&>div]:lg:mx-auto [&_.content]:h-[calc(100%-20px)]"
      >
        <div className="mt-5 mb-6 w-full">
          <UserInfo
            user={{ ...(data || {}), ...userData }}
            onDeactivate={onDeactivate}
            onDelete={onDelete}
          />
        </div>
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
        <div
          className={`${
            activeTab === "settings"
              ? "shadow-soft border border-border-secondary rounded-[10px] bg-surface-primary"
              : ""
          } tall3:h-[calc(100dvh-270px)]`}
        >
          {activeTab === "analytics" && <Analytics user={data} />}
          {activeTab === "calendar" && <Calendar user={data} />}
          {activeTab === "marketing" && <Marketing user={data} />}
          {activeTab === "pricing" && <Pricing user={data} />}
          {activeTab === "brand-assets" && <BrandAssets userId={userId} />}
          {activeTab === "settings" && <Settings user={data} />}
        </div>
      </FullScreenModal>
    </>
  );
}
